import { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  TextField,
  Checkbox,
  Button,
} from "@mui/material";
import SearchBar from "../../components/SearchBar";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useNavigate } from "react-router-dom";
import StockHistoryModal from "../../Modals/StockHistoryModal";

const ManageInventory = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const navigate = useNavigate();
  const [openStockHistory, setOpenStockHistory] = useState(false);

  const handleOpenStockHistory = () => {
    setOpenStockHistory(true);
  };

  const handleCloseStockHistory = () => {
    setOpenStockHistory(false);
  };

  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      setSelectedItems(filteredProducts.map((p) => p.id));
    } else {
      setSelectedItems([]);
    }
  };

  const toggleSelectItem = (id: string) => {
    setSelectedItems((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const products = [
    {
      id: "#PROD_001",
      name: "Wireless Mouse",
      variant: "Black Edition",
      price: "$99.99",
      quantity: 50,
      incomingStock: 20,
      warehouse: "Store A",
      stockStatus: "In Stock",
      vendor: { name: "John Doe", email: "john@example.com", phone: "+123456789" },
      image: "/static/images/placeholder.png",
    },
    {
      id: "#PROD_002",
      name: "Wireless Keyboard",
      variant: "RGB",
      price: "$129.99",
      quantity: 0,
      incomingStock: 50,
      warehouse: "Store B",
      stockStatus: "Out of Stock",
      vendor: { name: "Jane Smith", email: "jane@example.com", phone: "+987654321" },
      image: "/static/images/placeholder.png",
    },
    {
      id: "#PROD_003",
      name: "Gaming Headset",
      variant: "Surround Sound",
      price: "$89.99",
      quantity: 15,
      incomingStock: 30,
      warehouse: "Store C",
      stockStatus: "In Stock",
      vendor: { name: "Mike Johnson", email: "mike@example.com", phone: "+1122334455" },
      image: "/static/images/placeholder.png",
    },
    {
      id: "#PROD_004",
      name: "External Hard Drive",
      variant: "1TB",
      price: "$59.99",
      quantity: 0,
      incomingStock: 10,
      warehouse: "Store A",
      stockStatus: "Out of Stock",
      vendor: { name: "Sarah Lee", email: "sarah@example.com", phone: "+9988776655" },
      image: "/static/images/placeholder.png",
    },
    {
      id: "#PROD_005",
      name: "USB-C Hub",
      variant: "7-in-1",
      price: "$49.99",
      quantity: 100,
      incomingStock: 25,
      warehouse: "Store B",
      stockStatus: "In Stock",
      vendor: { name: "John Doe", email: "john@example.com", phone: "+123456789" },
      image: "/static/images/placeholder.png",
    },
    {
      id: "#PROD_006",
      name: "Laptop Stand",
      variant: "Aluminum",
      price: "$39.99",
      quantity: 5,
      incomingStock: 10,
      warehouse: "Store C",
      stockStatus: "In Stock",
      vendor: { name: "Jane Smith", email: "jane@example.com", phone: "+987654321" },
      image: "/static/images/placeholder.png",
    },
    {
      id: "#PROD_007",
      name: "Smartwatch",
      variant: "Series 8",
      price: "$299.99",
      quantity: 0,
      incomingStock: 50,
      warehouse: "Store A",
      stockStatus: "Out of Stock",
      vendor: { name: "Mike Johnson", email: "mike@example.com", phone: "+1122334455" },
      image: "/static/images/placeholder.png",
    },
    {
      id: "#PROD_008",
      name: "Bluetooth Speaker",
      variant: "Portable",
      price: "$79.99",
      quantity: 30,
      incomingStock: 15,
      warehouse: "Store B",
      stockStatus: "In Stock",
      vendor: { name: "Sarah Lee", email: "sarah@example.com", phone: "+9988776655" },
      image: "/static/images/placeholder.png",
    },
    {
      id: "#PROD_009",
      name: "Webcam",
      variant: "1080p HD",
      price: "$59.99",
      quantity: 0,
      incomingStock: 40,
      warehouse: "Store C",
      stockStatus: "Out of Stock",
      vendor: { name: "John Doe", email: "john@example.com", phone: "+123456789" },
      image: "/static/images/placeholder.png",
    },
    {
      id: "#PROD_010",
      name: "Desk Lamp",
      variant: "LED Touch",
      price: "$29.99",
      quantity: 70,
      incomingStock: 20,
      warehouse: "Store A",
      stockStatus: "In Stock",
      vendor: { name: "Jane Smith", email: "jane@example.com", phone: "+987654321" },
      image: "/static/images/placeholder.png",
    },
  ];


  const filteredProducts = products.filter((p) =>
    p.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <div className="main_title">
        <h1>Inventory Management</h1>
      </div>

      <div className="stats_boxes gap_m">
        <a className="cards">
          <div className="data_top">
            <h2>
              150
              <p>Total Products</p>
            </h2>
            <figure className="blue">
              <Inventory2OutlinedIcon fontSize="large" />
            </figure>
          </div>
        </a>

        <a className="cards">
          <div className="data_top">
            <h2>
              12
              <p>Low Stock</p>
            </h2>
            <figure className="warning">
              <ReportProblemOutlinedIcon fontSize="large" />
            </figure>
          </div>
        </a>

        <a className="cards">
          <div className="data_top">
            <h2>
              5
              <p>Out of Stock</p>
            </h2>
            <figure className="sucess">
              <BlockOutlinedIcon fontSize="large" />
            </figure>
          </div>
        </a>

        <a className="cards">
          <div className="data_top">
            <h2>
              1,250
              <p>Total Units</p>
            </h2>
            <figure className="sucess">
              <CategoryOutlinedIcon fontSize="large" />
            </figure>
          </div>
        </a>
      </div>
      <div className="table_flex mt_20">
        <div className="lt">
          {selectedItems.length > 0 && (
            <div className="bulk_action_bar" style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              padding: '10px 16px',
              background: '#fff',
              borderRadius: '8px',
              marginBottom: '16px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
              border: '1px solid #e5e7eb'
            }}>
              <Button
                variant="contained"
                sx={{
                  background: '#c49133',
                  '&:hover': { background: '#b0812b' },
                  textTransform: 'none',
                  borderRadius: '6px',
                  height: '36px',
                  fontSize: '14px',
                  fontWeight: 600
                }}
                endIcon={<KeyboardArrowDownIcon />}
              >
                {selectedItems.length} Selected
              </Button>

              <Button
                variant="outlined"
                sx={{
                  color: '#4b5563',
                  borderColor: '#d1d5db',
                  textTransform: 'none',
                  borderRadius: '6px',
                  height: '36px',
                  fontSize: '14px',
                  '&:hover': { borderColor: '#9ca3af', background: '#f9fafb' }
                }}
              >
                Pause Listing
              </Button>
              <Button
                variant="outlined"
                sx={{
                  color: '#4b5563',
                  borderColor: '#d1d5db',
                  textTransform: 'none',
                  borderRadius: '6px',
                  height: '36px',
                  fontSize: '14px',
                  '&:hover': { borderColor: '#9ca3af', background: '#f9fafb' }
                }}
              >
                Notify Vendor
              </Button>
              <Button
                variant="outlined"
                sx={{
                  color: '#4b5563',
                  borderColor: '#d1d5db',
                  textTransform: 'none',
                  borderRadius: '6px',
                  height: '36px',
                  fontSize: '14px',
                  '&:hover': { borderColor: '#9ca3af', background: '#f9fafb' }
                }}
              >
                Recommend Stock Increase
              </Button>

              <Button
                variant="outlined"
                onClick={handleOpenStockHistory}
                sx={{
                  color: '#4b5563',
                  borderColor: '#d1d5db',
                  textTransform: 'none',
                  borderRadius: '6px',
                  height: '36px',
                  fontSize: '14px',
                  '&:hover': { borderColor: '#9ca3af', background: '#f9fafb' }
                }}
              >
                View Stock History
              </Button>
              <Box
                component="a"
                onClick={() => setSelectedItems([])}
                sx={{
                  cursor: "pointer",
                  color: "#3b82f6",
                  ml: 'auto',
                  fontSize: "14px",
                  textDecoration: 'none',
                  '&:hover': { textDecoration: 'underline' }
                }}
              >
                Cancel
              </Box>
            </div>
          )}

          <div className="cards">
            <div className="table_header">
              <div className="left_s">
                <SearchBar
                  searchTerm={searchTerm}
                  setDebouncedSearchTerm={setSearchTerm}
                  placeholder="Search..."
                />
                <div className="form">
                  <select>
                    <option value="all">All Stores</option>
                    <option value="footwear">Store A</option>
                    <option value="clothing">Store B</option>
                    <option value="clothing">Store C</option>
                  </select>
                </div>
                <div className="form">
                  <select>
                    <option value="all">All Vendors</option>
                    <option value="footwear">Vendor A</option>
                    <option value="clothing">Vendor B</option>
                    <option value="clothing">Vendor C</option>
                  </select>
                </div>
              </div>
            </div>

            <TableContainer className="table_container" sx={{ mt: 3 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell padding="checkbox">
                      <Checkbox
                        indeterminate={selectedItems.length > 0 && selectedItems.length < filteredProducts.length}
                        checked={filteredProducts.length > 0 && selectedItems.length === filteredProducts.length}
                        onChange={handleSelectAll}
                      />
                    </TableCell>
                    <TableCell>Sr. No</TableCell>
                    <TableCell>Product ID</TableCell>
                    <TableCell>Vendor Details</TableCell>
                    <TableCell>Store Name</TableCell>
                    <TableCell>Product Details</TableCell>
                    <TableCell>Variant Name</TableCell>
                    <TableCell>Selling Price</TableCell>
                    <TableCell>Quantity</TableCell>
                    <TableCell>Incoming Stock</TableCell>
                    <TableCell>Stock Status</TableCell>

                  </TableRow>
                </TableHead>

                <TableBody>
                  {filteredProducts.map((item, index) => (
                    <TableRow key={index} hover selected={selectedItems.includes(item.id)}>
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={selectedItems.includes(item.id)}
                          onChange={() => toggleSelectItem(item.id)}
                        />
                      </TableCell>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{item.id}</TableCell>


                      <TableCell>
                        <Box
                          component="a"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/manage-vendors/view-vendor", { state: { user: item.vendor } });
                          }}
                          className="user_block click_action"
                        >
                          <p>
                            <b>{item.vendor.name}</b>
                            <span>
                              {item.vendor.email}{" "}
                              <img src="/static/images/tick_icon.svg" alt="verified" />
                            </span>
                            <span>{item.vendor.phone}</span>
                          </p>
                        </Box>
                      </TableCell>
                      <TableCell>{item.warehouse}</TableCell>
                      <TableCell>
                        <Box display="flex" alignItems="center" gap={1}>
                          <img
                            src={item.image}
                            alt={item.name}
                            style={{
                              width: "30px",
                              height: "30px",
                              borderRadius: "4px",
                              objectFit: "cover",
                              background: "#f5f5f5",
                            }}
                          />
                          <span>{item.name}</span>
                        </Box>
                      </TableCell>

                      <TableCell>{item.variant}</TableCell>
                      <TableCell>
                        <b>{item.price}</b>
                      </TableCell>

                      <TableCell>
                        {item.quantity}
                      </TableCell>

                      <TableCell>
                        {item.incomingStock}
                      </TableCell>

                      <TableCell>
                        <span
                          className={
                            item.stockStatus === "In Stock" ? "status_chip active" : "status_chip error"
                          }>
                          {item.stockStatus}
                        </span>
                      </TableCell>


                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <div style={{ marginTop: "10px", textAlign: "right" }}>
              <p>Showing 1 to {filteredProducts.length} of {filteredProducts.length} entries</p>
            </div>
          </div>
        </div>
        <div className="rt">
          <div className="ai_panel">
            <h4>AI Insights</h4>

            <div className="ai_alert warning">
              <span className="icon">⚠️</span>
              <p>
                <b>7 SKUs</b> need immediate attention
              </p>
            </div>

            <div className="ai_alert danger">
              <span className="icon">⛔</span>
              <p>
                <b>3 SKUs</b> have zero sales in 30 days
              </p>
            </div>

            <small className="ai_update">
              Next updated ETA: <b>May 5, 2024</b>
            </small>

            <div className="ai_sku_list">
              <div className="ai_sku_row">
                <div className="ai_sku_info">
                  <h5>#PRD_002</h5>
                  <p>Likely to go out of stock by May</p>
                </div>
                <button className="ai_action_btn">Actions ▾</button>
              </div>

              <div className="ai_sku_row">
                <div className="ai_sku_info">
                  <h5>#PRD_010</h5>
                  <p>Likely to go out of stock by May</p>
                </div>
                <button className="ai_action_btn">Actions ▾</button>
              </div>
            </div>

            {/* <div className="ai_create">
                                    + Create AI Insights
                                </div> */}
          </div>
        </div>
      </div>

      <StockHistoryModal
        open={openStockHistory}
        handleClose={handleCloseStockHistory}
      />
    </>
  );
};

export default ManageInventory;